import { Check, Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { OPTION_COLORS } from "@/components/game/common";
import { Button } from "@/components/ui/button";

const OptionBlock = ({ o, i, form, update, track, canRemove, onRemove }) => {
  const correct = o.id === form.correct_option_id;
  const tf = form.type === "true_false";
  return (
    <div className={`rounded-lg border p-3 space-y-2 ${correct ? "border-[#34D399]/70 bg-[#34D399]/5" : "border-[rgba(71,85,105,0.45)]"}`} data-testid={`option-block-${o.id}`}>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => update({ correct_option_id: o.id })} aria-label="Doğru cevap olarak işaretle"
          className={`h-9 w-9 shrink-0 grid place-items-center rounded-md border font-bold uppercase ${correct ? "bg-[#34D399] border-[#34D399] text-[#05070D]" : "border-[rgba(100,116,139,0.6)] text-slate-300 hover:border-[#34D399]"}`}
          data-testid={`option-correct-${o.id}`}>
          {correct ? <Check className="h-5 w-5" /> : o.id}
        </button>
        <Input value={o.text} disabled={tf} onFocus={(e) => track(`opt-${i}-text`, e.target)}
          onChange={(e) => update({ options: form.options.map((x, j) => (j === i ? { ...x, text: e.target.value } : x)) })}
          placeholder={`${o.id.toUpperCase()} şıkkı`} className="h-11 text-base" data-testid={`option-text-${o.id}`} />
        <label className="relative h-11 w-11 shrink-0 rounded-md border border-white/15 cursor-pointer overflow-hidden" title="Şık rengi" style={{ backgroundColor: o.color || OPTION_COLORS[o.id] }}>
          <input type="color" value={o.color || OPTION_COLORS[o.id]} className="absolute inset-0 opacity-0 cursor-pointer" data-testid={`option-color-${o.id}`}
            onChange={(e) => update({ options: form.options.map((x, j) => (j === i ? { ...x, color: e.target.value.toUpperCase() } : x)) })} />
        </label>
        {o.color && <button type="button" className="text-xs text-slate-400 hover:text-white" onClick={() => update({ options: form.options.map((x, j) => (j === i ? { ...x, color: "" } : x)) })} data-testid={`option-color-reset-${o.id}`}>Varsayılan</button>}
        {canRemove && (
          <Button type="button" variant="ghost" size="icon" onClick={onRemove} data-testid={`option-remove-${o.id}`} aria-label="Şıkkı sil">
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </div>
      {!correct && (
        <div className="grid sm:grid-cols-2 gap-2 pl-11">
          <Input value={o.misconception} onFocus={(e) => track(`opt-${i}-misconception`, e.target)}
            onChange={(e) => update({ options: form.options.map((x, j) => (j === i ? { ...x, misconception: e.target.value } : x)) })}
            placeholder="Yanılgı etiketi (yalnızca öğretmen)" className="h-9 text-sm" data-testid={`option-misconception-${o.id}`} />
          <Input value={o.hint} onFocus={(e) => track(`opt-${i}-hint`, e.target)}
            onChange={(e) => update({ options: form.options.map((x, j) => (j === i ? { ...x, hint: e.target.value } : x)) })}
            placeholder="Öğrenciye ipucu (telefonda görünür)" className="h-9 text-sm" data-testid={`option-hint-${o.id}`} />
        </div>
      )}
    </div>
  );
};

export const OptionFields = ({ form, update, track }) => {
  const tf = form.type === "true_false";
  const addOption = () => {
    const id = "abcd".split("").find((c) => !form.options.some((o) => o.id === c));
    update({ options: [...form.options, { id, text: "", misconception: "", hint: "" }] });
  };
  const removeOption = (i) => {
    const options = form.options.filter((_, j) => j !== i);
    const keep = options.some((o) => o.id === form.correct_option_id);
    update({ options, correct_option_id: keep ? form.correct_option_id : options[0].id });
  };
  return (
    <div className="space-y-2">
      <p className="text-sm text-slate-400">Doğru cevabı soldaki harfe tıklayarak işaretleyin. Sağdaki kareden şık rengini seçebilirsiniz. Yanlış şıklar için yanılgı etiketi ve ipucu isteğe bağlıdır.</p>
      {form.options.map((o, i) => (
        <OptionBlock key={o.id} o={o} i={i} form={form} update={update} track={track}
          canRemove={!tf && form.options.length > 2} onRemove={() => removeOption(i)} />
      ))}
      {!tf && form.options.length < 4 && (
        <Button type="button" variant="outline" onClick={addOption} data-testid="option-add-button"><Plus className="h-4 w-4 mr-1" />Şık ekle</Button>
      )}
    </div>
  );
};
